import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const e = r((t, a) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: a,
    ...t,
    image: (o) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 3375,
        height: 2125,
        fill: "none",
        viewBox: "0 0 3375 2125",
        ...o,
        children: [
          /* @__PURE__ */ s.jsx("path", { fill: "#FF5A00", d: "M2142.81 242.365h-913.33V1883.98h913.33z" }),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#EB001B",
              d: "M1290.28 1063.17c0-333.525 156.73-629.542 397.22-820.805C1510.51 103.142 1287.24 19 1043.71 19 466.798 19 0 486.005 0 1063.17c0 577.17 466.798 1044.17 1043.71 1044.17 243.53 0 466.8-84.14 643.79-223.36-240.83-188.56-397.22-487.28-397.22-820.81"
            }
          ),
          /* @__PURE__ */ s.jsx(
            "path",
            {
              fill: "#F79E1B",
              d: "M3375 1063.17c0 577.17-466.8 1044.17-1043.71 1044.17-243.53 0-466.8-84.14-643.79-223.36 243.53-191.6 397.22-487.28 397.22-820.81 0-333.525-156.73-629.542-397.22-820.805C1864.15 103.142 2087.42 19 2330.95 19 2908.2 19 3375 489.046 3375 1063.17"
            }
          )
        ]
      }
    )
  }
));
e.displayName = "MastercardIcon";
export {
  e as MastercardIcon,
  e as default
};
//# sourceMappingURL=index.js.map
